import React from 'react';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Zoom from '@material-ui/core/Zoom';
// import formatDistanceToNow from 'date-fns/formatDistanceToNow';
// import Divider from '@material-ui/core/Divider';
import useMemberInfo from 'hooks/useMemberInfo';
import UserContext from 'contexts/UserContext';
import Divider from '@material-ui/core/Divider';
import { THREAD_SUBJ_PRE } from './ShopTalk';
import get from 'lodash/get';

const useBubbleStyles = makeStyles({
  root: {
    '& > span': {
      display: 'block'
    },
    '& > div': {
      display: 'inline-block'
    }
  },
  body: {
    padding: 10,
    backgroundColor: props => props.bgColor,
    '& > hr': { marginBottom: 10 }
  },
  me: {
    float: 'right',
    width: '100%',
    textAlign: 'right'
  },
  announcement: { width: '100%', float: 'none', textAlign: 'center' }
});

function toHexColour(text) {
  function hashCode(str) {
    var hash = 0;
    for (var i = 0; i < str.length; i++) {
      hash = str.charCodeAt(i) + ((hash << 5) - hash);
    }
    return hash;
  }

  function intToARGB(i) {
    var hex =
      ((i >> 24) & 0xff).toString(16) +
      ((i >> 16) & 0xff).toString(16) +
      ((i >> 8) & 0xff).toString(16) +
      (i & 0xff).toString(16);
    hex += '000000';
    return hex.substring(0, 6);
  }
  return intToARGB(hashCode(text));
}

export default function BubbleComment({ comment }) {
  const member = useMemberInfo({ userId: comment.userId });
  const { currentUser } = React.useContext(UserContext);
  const isMyself = currentUser.username === comment.userId;
  const subject = comment.threadCommentThreadId;
  const isStoreAnnouncement =
    subject === THREAD_SUBJ_PRE + get(currentUser, 'memberInfo.store.id');
  console.log(
    '>>CoachCornerPage/BubbleComment::',
    '',
    subject,
    THREAD_SUBJ_PRE + get(currentUser, 'memberInfo.store.id'),
    isStoreAnnouncement
  ); //TRACE

  const bgColor = React.useMemo(() => {
    return '#' + toHexColour(comment.userId);
  }, [comment.userId]);
  const classes = useBubbleStyles({ bgColor, isStoreAnnouncement });

  let rootClass = classes.root;
  if (isMyself) {
    rootClass += ' ' + classes.me;
  }
  if (isStoreAnnouncement) {
    rootClass += ' ' + classes.announcement;
  }

  return (
    <Zoom in>
      <div className={rootClass}>
        <span>
          {member ? (
            <Typography variant="caption">
              {member.firstName} ▪ {new Date(comment.createdAt).toLocaleString()}
            </Typography>
          ) : (
            '...'
          )}
        </span>
        <Paper elevation={10} className={classes.body}>
          {isStoreAnnouncement && (
            <>
              <Typography variant="overline">⭐Announcement⭐</Typography>
              <Divider />
            </>
          )}
          {comment.body}
        </Paper>
      </div>
    </Zoom>
  );
}
